import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/es')) {
      setLang('es');
    } else {
      setLang('en');
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = lang === 'en' ? 'es' : 'en';
    setLang(newLang);
    const path = window.location.pathname;
    if (newLang === 'es') {
      if (!path.startsWith('/es')) {
        const newPath = path === '/' ? '/es' : `/es${path}`;
        window.history.pushState({}, '', newPath);
      }
    } else {
      if (path.startsWith('/es')) {
        const newPath = path.replace(/^\/es/, '') || '/';
        window.history.pushState({}, '', newPath);
      }
    }
  };

  const t = (enText, esText) => {
    return lang === 'es' && esText ? esText : enText;
  };

  const getLocalized = (obj) => {
    if (!obj) return {};
    return obj[lang] || obj['en'] || {};
  };

  const getLocalizedPath = (path) => {
    if (lang === 'es') {
      return `/es${path === '/' ? '' : path}`;
    }
    return path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t, getLocalized, getLocalizedPath }}>
      {children}
    </LanguageContext.Provider>
  );
};
